<template>
  <div>
    <div class="detail-title mb-top20">
      <gj-area-title>发货信息</gj-area-title>
    </div>
    <gj-table
      :data="tableData"
      :columns="columns"
      :loading="loading"
      :adapt-height="false"
      :show-overflow="false"
      :index="false"
      :isMinHeight="true"
      class="detail-table-remove-hover"
    >
      <template v-slot:listingInfo="{ row }">
        <div class="flex justify-between align-center">
          <div style="width: 80%">
            <gj-tooltip :text-line="1" class="item" :content="row.productName" placement="top">
              <div class="text-ellipsis-1">{{row.productName| defaultShow}}</div>
            </gj-tooltip>
            <el-row>
              <el-col :span="11">
                  <span>ASIN：</span>
                  <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
                  <gj-copy-icon v-if="isMeaningful(row.asin)" :content="row.asin"/>
              </el-col>
              <el-col :span="13">
                  <span>MSKU：</span><span>{{row.msku | defaultShow}}<gj-copy-icon v-if="isMeaningful(row.msku)" :content="row.msku"/></span>
              </el-col>
            </el-row>
          </div>
          <div style="width: 18%">
            数量: {{row.quantityShipped}}
          </div>
        </div>
      </template>
    </gj-table>
  </div>
</template>

<script>
import { getAmazonShipmentPage } from "@/api/sale";
import { isMeaningful } from "@/utils/common";
import { isMeaningfulMixin } from "@/minxins";
export default {
    name: "sale-order-shipping-info",
    props: {
      marketId: {
        required: true,
      },
      orderId: {
        required: true,
        type: String,
      }
    },
    mixins: [isMeaningfulMixin],
    created() {
      this.loadOrderDetail();
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'imageUrl', header: '图片', field: 'picture:imageUrl', minWidth: '100px', maxWidth: '100px', default: true},
          {id: 'listingInfo', header: '商品信息', field: 'slot:listingInfo', minWidth: '460px', default: true},
          {id: 'shipmentMarketDate', header: '发货时间', field: 'shipmentMarketDate', minWidth: '120px', default: true},
          {id: 'carrier', header: '承运人', field: 'carrier', minWidth: '110px', default: true},
          {id: 'estimatedArrivalMarketDate', header: '预计收货时间', field: 'estimatedArrivalMarketDate', minWidth: '120px', default: true},
          {id: 'trackingNumber', header: '物流跟踪号', field: 'trackingNumber', minWidth: '130px', default: true},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '120px', default: true}
        ],
        loading: false
      }
    },
    methods: {
      loadOrderDetail() {
        this.loading = true;
        const params = {
          model: {
            orderId: this.orderId,
            marketIds: [this.marketId]
          },
          current: 1,
          size: 50
        }
        getAmazonShipmentPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
                this.tableData = data.records;
            }
          }).complete(() => this.loading = false)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .mb-top20 {
    margin-top: 20px;
  }

  .detail-title {
    margin-bottom: 12px;
  }
</style>